import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "trigger"]

  connect() {
    this.files = []
  }

  trigger() {
    this.inputTarget.click()
  }

  select(event) {
    const newFiles = Array.from(event.target.files)
    const remaining = 5 - this.files.length
    newFiles.slice(0, remaining).forEach(file => this.files.push(file))
    event.target.value = ""
    this.render()
    this.sync()
  }

  remove(event) {
    this.files.splice(parseInt(event.currentTarget.dataset.photoIndex), 1)
    this.render()
    this.sync()
  }

  render() {
    this.previewTarget.innerHTML = ""
    this.files.forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const item = document.createElement("div")
        item.className = "d-inline-block position-relative me-2 mb-2"
        item.innerHTML = `
          <img src="${e.target.result}"
               style="width: 90px; height: 90px; object-fit: cover; border-radius: 6px; display: block;">
          <button type="button"
                  class="btn btn-danger btn-sm d-flex align-items-center justify-content-center position-absolute top-0 end-0"
                  style="width: 20px; height: 20px; border-radius: 50%; padding: 0; transform: translate(40%, -40%);"
                  data-action="click->photo-upload#remove"
                  data-photo-index="${index}">
            <i class="bi bi-x" style="font-size: 11px; line-height: 1;"></i>
          </button>`
        this.previewTarget.appendChild(item)
      }
      reader.readAsDataURL(file)
    })

    const count = this.files.length
    if (count >= 5) {
      this.triggerTarget.disabled = true
      this.triggerTarget.innerHTML = `<i class="bi bi-images me-1"></i>Maximum atteint (5/5)`
    } else {
      this.triggerTarget.disabled = false
      this.triggerTarget.innerHTML = `<i class="bi bi-plus-circle me-1"></i>Ajouter une photo${count > 0 ? ` (${count}/5)` : ""}`
    }
  }

  sync() {
    const dt = new DataTransfer()
    this.files.forEach(file => dt.items.add(file))
    this.inputTarget.files = dt.files
  }
}
